module.exports = __webpack_public_path__ + "6b03ffb82223ffdcc7fc093f199f758b.png";